import React from 'react';

const Image = ({
  height = '48px',
  width = '48px',
  color = '#42A6DD',
  mountainColor = '#BADEFC',
  sunColor = '#EFD358'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>add image</title>
    <g>
      <path d="M45,47H3c-1.10457,0-2-0.89543-2-2V3c0-1.10457,0.89543-2,2-2h42c1.10457,0,2,0.89543,2,2v42 C47,46.10457,46.10457,47,45,47z" fill={color} />
      <circle cx="21" cy="15" fill={sunColor} r="4" />
      <path d="M41.79248,35.39014l-10-13c-0.37793-0.49219-1.20703-0.49219-1.58496,0l-8.24268,10.71545l-6.18408-7.7301 c-0.37891-0.47461-1.18262-0.47461-1.56152,0l-8,10C5.69676,36.02752,6.16103,37,7,37h34 C41.82902,37,42.29784,36.04732,41.79248,35.39014z" fill={mountainColor} />
    </g>
  </svg>
);

export default Image;
